import {
  Dialog,
  Button,
  DialogContent,
  Slide,
  CircularProgress,
  Typography,
  Grid,
  IconButton,
} from "@material-ui/core";
import { CropFreeRounded } from "@material-ui/icons";

import React from "react";
import QR from "react-qr-code";
import { connect } from "react-redux";
import { setQrCode } from "../redux/Orders/OrderActionCreators";

import { changeActiveOrdersState } from "../redux/Orders/ordersActions";
import Store from "../redux/Store";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const QrCode = ({ rowValue, qrCode, qrLoad, icon, message, orderId }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    Store.dispatch(setQrCode(null));
    // Store.dispatch(set_Current_Order(rowValue));
  };

  const handleCloseDialog = () => {
    setOpen(false);
    // Store.dispatch(set_Let_Refresh(true));
  };

  return (
    <>
      {!icon ? (
        <Button
          color="primary"
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            handleClickOpen();
            changeActiveOrdersState(orderId);
            // Store.dispatch(set_Refresh(refresh + 1));
          }}
        >
          پرینت بارکد
        </Button>
      ) : (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleClickOpen();
            changeActiveOrdersState(orderId);
            // Store.dispatch(set_Refresh(refresh + 1));
          }}
        >
          <CropFreeRounded color="primary" />
        </IconButton>
      )}
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={open}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        onClick={(e) => e.stopPropagation()}
      >
        <DialogContent style={{ textAlign: "center" }}>
          {qrLoad === true ? (
            <CircularProgress color="inherit" />
          ) : qrCode === null ? (
            <Typography variant="h6" color="textSecondary">
              {message}
            </Typography>
          ) : (
            <Grid item container xs={12} justifyContent="space-between">
              <Grid item container xs={8} style={{}}>
                <Typography variant="body1">مشخصات</Typography>
                <Grid justifyContent="flex-start" container item xs={12}>
                  <Typography variant="button">
                    نام و نام خانوادگی :{`${qrCode.addresse.receiver_name}`}
                  </Typography>
                </Grid>
                <Grid item xs={12} justifyContent="flex-start" container>
                  <Typography variant="button">
                    شماره موبایل :{`${qrCode.addresse.receiver_phone}`}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "start" }}
                  justifyContent="flex-start"
                  container
                >
                  <Typography variant="button">
                    آدرس :
                    {`${qrCode.addresse.descr}${
                      qrCode.addresse.detail !== null
                        ? "-" + qrCode.addresse.detail
                        : ""
                    }`}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <QR value={qrCode.barcode} size={180} />
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = (props) => {
  const { OrderReducer } = props;
  const { qrCode, qrLoad, refresh, message } = OrderReducer;

  return { qrCode, qrLoad, refresh, message };
};

export default connect(mapStateToProps)(QrCode);
